import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PictogramStructureState } from './pictogram-structure.state';


const pictogramStructure = createFeatureSelector<PictogramStructureState>('pictogramStructures');

export const selectPictogramStructures = createSelector(pictogramStructure, (state) => state.structures);
export const selectError = createSelector(pictogramStructure, (state) => state.error);
export const selectSelectedPictogramStructureUUID = createSelector(pictogramStructure, (state) => state.selectedUUID);
